import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { LicenseService } from 'app/core/services/license.service';
import { DomainService } from 'app/core/services/domain.service';
import { Observable, Subject } from 'rxjs';
import { RxComponent } from 'app/shared/components/common/rx.component';
import { CommBoxConfig } from 'app/core/components/workflow-new/common/communication-box/communication-box.component';

@Component({
  selector: 'itpx-register-voucher-new',
  templateUrl: './register-voucher-new.component.html',
  styleUrls: ['./register-voucher-new.component.css', '../login/login.component.css']
})
export class RegisterVoucherNewComponent extends RxComponent implements OnInit {
  domain: any;
  form: FormGroup;
  formSubmit = new Subject<any>();
  disableButton: boolean;
  showMessage: boolean;
  commBoxConfig: CommBoxConfig;
  username: { username: string; };

  constructor(
    private fb: FormBuilder,
    private licenseService: LicenseService,
    private domainService: DomainService,
  ) {
    super();
  }

  ngOnInit() {
    this.domain = this.domainService.getDomain();

    this.form = this.fb.group({
      iVoucher: [null, [Validators.required]],
      username: [null, [Validators.required, Validators.email]],
    });

    this.form.statusChanges.startWith('INVALID').bindToLifecycle(this).subscribe(status => this.disableButton = status === 'INVALID');

    this.formSubmit
      .switchMap(input => this.getFormSubmitQuery(input)) //error if user already registered, if voucher does not exist, if race condition amongst two learners with same voucher
      .neverError()
      .bindToLifecycle(this)
      .subscribe(res => {
        this.form.reset();
        this.username = { username: res.username }
        this.showMessage = true;
      })
  }

  protected getFormSubmitQuery(data: any): Observable<any> {
    return this.licenseService.redeemVoucherRegistration({ voucher: data.iVoucher, learner: data.username })
      .map(body => body.data)
      .catch((err: any) => {
        const e = err.json();
        this.commBoxConfig = {
          message: e.error.message.replace(e.error.code[0] + ' ', ''),
          level: 'err'
        };
        return Observable.empty();
      });
  }

  private onRegister({ value, valid }: { value: any, valid: boolean }) {
    this.disableButton = true;
    this.formSubmit.next(value);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/register-voucher-new/register-voucher-new.component.ts